import { contentPrinciples, testimonials } from '@/mocks/feed';
import SectionHeading from '@/components/base/SectionHeading';

export default function TrustSection() {
  return (
    <section className="mx-auto w-full max-w-[1440px] px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="Our Principles"
        title="整理内容之前，先想清楚边界"
        desc="深夜信息最容易被放大，所以我们给自己定了几条不太讨巧、但必须守住的规矩。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {contentPrinciples.map((item, index) => (
          <article key={item.title} className="rounded-lg border border-background-200/70 bg-background-100/50 p-5">
            <span className="font-display text-2xl tracking-wide text-primary-400">
              {String(index + 1).padStart(2, '0')}
            </span>
            <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
          </article>
        ))}
      </div>

      <div className="mt-14">
        <SectionHeading
          eyebrow="Night Owls Say"
          title="夜里的读者怎么说"
          desc="这些话来自长期在凌晨刷我们更新的读者，也是我们继续值夜的理由。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex h-full flex-col rounded-lg border border-background-200/70 bg-background-100/50 p-5">
              <i className="ri-double-quotes-l text-2xl text-accent-500/50" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{t.text}</blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200/70 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-500/20 font-label text-sm text-secondary-200">
                  {t.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm text-foreground-900">{t.name}</span>
                  <span className="block text-xs text-foreground-500">{t.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}